// A language the guest picked while signed out. It is kept through logout and wins over the account's
// saved language at the next login; it is cleared only after the choice is saved to the account.
import api from './api';
import { setLanguage } from '../i18n';

const KEY = 'langOverride';

export function markGuestLanguageChoice(code) {
  localStorage.setItem(KEY, code);
}

// Call after the token is stored. Without an override the account's saved language loads (if it has one).
export async function applyLoginLanguage(accountLanguage) {
  const pending = localStorage.getItem(KEY);
  if (!pending) {
    if (accountLanguage) setLanguage(accountLanguage);
    return;
  }
  setLanguage(pending);
  try {
    await api.patch('/api/users/me', { language: pending });
    // Clear only if nothing newer was chosen while the save was in flight
    if (localStorage.getItem('lang') === pending) localStorage.removeItem(KEY);
    const stored = JSON.parse(localStorage.getItem('user') || 'null');
    if (stored) localStorage.setItem('user', JSON.stringify({ ...stored, language: pending }));
  } catch (err) {
    // The override stays, so the next login tries again
    console.error('Could not save the guest language to the account', err);
  }
}
